import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-alert-list-display',
  templateUrl: './alert-list-display.component.html',
  styleUrls: ['./alert-list-display.component.scss'],
  imports: [],
})
export class AlertListDisplayComponent {
  @Input() dataItem;
  @Input() headers = [];

  alertListDisplay(value) {
    if (value.includes(',')) {
      const newList = [];
      value.split(',').map(alertId => {
        const alertHeader = this.headers
          ?.find(header => header.DataField === 'AlertIDs')
          .Validation?.find(alert => alert.value === alertId);
        if (alertHeader) {
          newList.push(alertHeader.label);
        }
      });
      return newList.join(', ');
    } else if (
      value !== '' &&
      this.headers
        ?.find(header => header.DataField === 'AlertIDs')
        .Validation?.find(alert => alert.value === value)
    ) {
      return this.headers
        ?.find(header => header.DataField === 'AlertIDs')
        .Validation?.find(alert => alert.value === value).label;
    }

    return value;
  }
}
